var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 17.7139H16.2422C16.6719 17.7139 16.9082 17.5205 16.9082 17.166C16.9082 16.8008 16.6719 16.6182 16.2422 16.6182H14.4268V1.10645H16.2422C16.6719 1.10645 16.9082 0.902344 16.9082 0.537109C16.9082 0.193359 16.6719 0 16.2422 0H11.3438C10.9033 0 10.6777 0.193359 10.6777 0.537109C10.6777 0.902344 10.9033 1.10645 11.3438 1.10645H13.1484V16.6182H11.3438C10.9033 16.6182 10.6777 16.8008 10.6777 17.166C10.6777 17.5205 10.9033 17.7139 11.3438 17.7139Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.816406 15.125C1.32129 15.125 1.5791 14.9316 1.76172 14.3945L2.73926 11.6768H7.53027L8.50781 14.3945C8.69043 14.9316 8.94824 15.125 9.45312 15.125C9.95801 15.125 10.291 14.8242 10.291 14.3301C10.291 14.1689 10.2588 14.0293 10.1836 13.8145L6.38086 3.58789C6.15527 2.98633 5.75781 2.69629 5.13477 2.69629C4.52246 2.69629 4.125 2.98633 3.91016 3.57715L0.107422 13.8252C0.0214844 14.04 0 14.1797 0 14.3408C0 14.835 0.311523 15.125 0.816406 15.125ZM3.22266 10.1943L5.12402 4.80176H5.17773L7.0791 10.1943H3.22266Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/rename_icon.600891dd742a180ef78d247bf8196646.svg";
export { ForwardRef as ReactComponent };